var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.currentData?.type === "select"
    ? _c(_setup.FormSelectOptions, {
        attrs: {
          "current-data": _setup.currentData,
          field: _vm.field,
          "form-id": _vm.formId,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }